/**
 * Feature flags for controlling functionality across the application
 */
export const FEATURE_FLAGS = {
  /**
   * Enable reply functionality for comments
   * @default false
   */
  ENABLE_COMMENT_REPLY: false,

  /**
   * Enable like/reaction functionality for comments
   * @default false
   */
  ENABLE_COMMENT_LIKE: true,

  /**
   * Show the Promocodes tab in the account section
   * @default false
   */
  ENABLE_PROMOCODES: true,

  /**
   * Animate Payout / Avg. price numbers in the order form summary
   * @default false
   */
  ENABLE_ORDER_SUMMARY_ANIMATION: false,

  /**
   * Passkey (WebAuthn) sign-in and management — Settings row, /account/passkeys,
   * and the login page's passkey button. Independent of the backend's own
   * PASSKEY_ENABLED (which just 404s the API while off).
   * @default false
   */
  ENABLE_PASSKEY: true,

  /**
   * KYC verification — the forced lockdown gate, the Settings card/wizard and the status request
   * that drives the order form's close-only restriction. Off = KYC is invisible everywhere (the
   * forced-KYC lockdown never shows even though the backend already restricts the account).
   * @default false
   */
  ENABLE_KYC: true,

  /**
   * KYC "Verify with Phone" — the QR handoff card on the face step (selfie taken on the phone
   * via kyc-service mobile-session).
   * @default false
   */
  ENABLE_KYC_PHONE_HANDOFF: true,

  /**
   * Crypto trading (the apps/trade zone) — its routes (the zone redirects to the
   * markets home while off), every link into it (header, footer, bottom nav,
   * sitemap, the account's Deals → Crypto Trading, the Crypto Trading
   * transactions tab) and the profile's Crypto Trading / Prediction Markets
   * switch.
   * @default true
   */
  ENABLE_TRADE_ZONE: true,

  /**
   * Trade zone: the Predict and News tabs next to the chart. UI-only on mock data
   * until the backend contract exists.
   * @default false
   */
  ENABLE_TRADE_PAIR_PREDICT_NEWS: false,

  /**
   * News zone: tweets — the "Posts from Outpoll" marquee on the news home and the
   * embedded X posts block in articles. Off = the home makes no RapidAPI timeline
   * call at all; articles still fetch their tweets because key figures reuse the
   * user objects they carry. Off while the RapidAPI twttrapi subscription is
   * inactive (every call answers 403 "You are not subscribed to this API").
   * @default false
   */
  ENABLE_NEWS_TWEETS: false,

  /**
   * Header "Card" entry with its animated card icon. Off until the card
   * landing it links to (/card) is built.
   * @default false
   */
  ENABLE_CARD_NAV: false,
} as const;
